"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usa_date_picker_1 = __importDefault(require("@uswds/uswds/js/usa-date-picker"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const __1 = require("..");
const __2 = require("../..");
const DatePicker = (0, react_1.forwardRef)(({ children, className, disabled, error, hint = 'mm/dd/yyyy', id, maxDate, minDate, onChange, rangeDate, value, ...props }, ref) => {
    const labelId = `${id}-label`;
    const hintId = `${id}-hint`;
    const containerRef = (0, react_1.useRef)(null);
    const datePickerRef = (0, react_1.useRef)(null);
    const inputRef = (0, react_1.useRef)(null);
    (0, react_1.useImperativeHandle)(ref, () => inputRef.current);
    const [ready, setReady] = (0, react_1.useState)(false);
    // initialization
    (0, react_1.useEffect)(() => {
        const containerEl = containerRef.current;
        const inputEl = inputRef.current;
        if (!containerEl || !inputEl)
            return;
        // call USWDS's `on` function to initialize the component
        usa_date_picker_1.default.on(containerEl);
        setReady(true);
        // hook into the input's `change` event to monitor changes
        inputEl.addEventListener('change', (e) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (onChange)
                onChange(e);
        });
        // on dismount, call USWDS's `off` function to cleanup the component
        return () => {
            usa_date_picker_1.default.off(containerEl);
        };
    }, []);
    // call USWDS's `setCalendarValue` when the value changes
    // outside of this component
    (0, react_1.useEffect)(() => {
        const hiddenInputEl = inputRef.current;
        const datePickerEl = datePickerRef.current;
        if (!hiddenInputEl || !datePickerEl)
            return;
        if (value !== hiddenInputEl.value) {
            if (!value) {
                // reset the date picker
                const shownInputEl = datePickerEl.querySelector('.usa-date-picker__external-input');
                shownInputEl.value = '';
                hiddenInputEl.value = '';
            }
            else {
                usa_date_picker_1.default.setCalendarValue(datePickerEl, value);
            }
        }
    }, [value, inputRef, datePickerRef]);
    // call USWDS's `enable` or `disable` function when the disabled prop changes
    (0, react_1.useEffect)(() => {
        const datePickerEl = datePickerRef.current;
        if (!datePickerEl)
            return;
        const disabledState = datePickerEl.querySelector(`#${id}`).disabled;
        if (disabled === disabledState)
            return; // the input already has the right disabled state
        if (disabled)
            usa_date_picker_1.default.disable(datePickerEl);
        else
            usa_date_picker_1.default.enable(datePickerEl);
    }, [disabled]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "bah-uswds-date-picker", style: { display: ready ? 'block' : 'none' }, ref: containerRef, children: [(0, jsx_runtime_1.jsx)(__1.Label, { error: error, id: labelId, target: id, children: children }), (0, jsx_runtime_1.jsx)(__1.Form.Error, { error: error }), (0, jsx_runtime_1.jsx)(__2.Hint, { id: hintId, children: hint }), (0, jsx_runtime_1.jsx)("div", { className: "usa-date-picker", "data-default-value": value, "data-max-date": maxDate, "data-min-date": minDate, "data-range-date": rangeDate, ref: datePickerRef, children: (0, jsx_runtime_1.jsx)("input", { ref: inputRef, className: (0, uswds_react_utils_1.createClassString)('usa-input', className), disabled: disabled, id: id, ...props, "aria-describedby": hintId, "aria-labelledby": labelId, name: id, type: "text" }) })] }));
});
exports.default = DatePicker;
